<template>

 <text-input type="area" :rows="rows" :label="label" :disabled="disabled" />

</template>

<script>

export default {
  name: 'text-area',

  props: {
    label: {
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    },

    rows: {
      type: Number,
      default: 4
    }
  }

}

</script>
